import React, { createContext, useContext } from 'react';
import { ResourceArticleTiny } from 'src/api/models/Resources';

interface ResourceCategoryType {
  articles: ResourceArticleTiny[];
  category: string;
  subCategory?: string;
}

interface ResourceCategoryResponse {
  articles: ResourceArticleTiny[];
  category: string;
  subCategory?: string;
}

const ResourceCategory = createContext<ResourceCategoryType>({
  articles: [],
  category: '',
  subCategory: '',
});

interface ResourceCategoryProviderProps {
  children: React.ReactNode;
  category: string;
  subCategory?: string;
  articles: ResourceArticleTiny[];
}

export const ResourceCategoryProvider: React.FC<ResourceCategoryProviderProps> = ({
  children,
  category,
  subCategory,
  articles,
}) => {
  return <ResourceCategory.Provider value={{ articles, category, subCategory }}>{children}</ResourceCategory.Provider>;
};

export const useResourceCategory = (): ResourceCategoryResponse => {
  const context = useContext(ResourceCategory);

  if (!context) {
    throw new Error('useResourceCategory must be used within a ResourceCategoryProvider');
  }

  return {
    articles: context.articles,
    category: context.category,
    subCategory: context.subCategory,
  };
};
